/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_6cdab8e4',
  resizeIsShort: 'resizeIsShort_6cdab8e4',
  buttonGroup: 'buttonGroup_6cdab8e4',
};

export = styles;

loadStyles([{"rawString":".root_6cdab8e4{display:block}.resizeIsShort_6cdab8e4{width:400px}.buttonGroup_6cdab8e4{margin-bottom:40px}.buttonGroup_6cdab8e4 button{margin-right:20px}"}]);
/* tslint:enable */